import gql from "graphql-tag";

export const SAVE_FULL_DAY_PREVIEW = gql`
  mutation saveFullDayPreview($where: [SheetRowDayPreviewInput!]!) {
    saveFullDayPreview(where: $where)
  }
`;